import { useEffect, useState } from "react";
import type { Product } from "./catalog";
import { useCart } from "./cart";
import { categoryIcon } from "./categoryIcon";
import { formatMoney } from "./money";

// Deliberately no stock/availability badge here: the catalog's
// `initialStock` is a seed value for inventory-service's DynamoDB table
// (ADR 0023), not live on-hand quantity, and this feature has no read path
// to the real number (ADR 0036) — showing one would be a guess dressed up
// as data. Real availability is only known at checkout, same as any real
// storefront.
export function ProductCard({ product }: { product: Product }) {
  const { add } = useCart();
  const [justAdded, setJustAdded] = useState(false);

  useEffect(() => {
    if (!justAdded) return;
    const t = setTimeout(() => setJustAdded(false), 1200);
    return () => clearTimeout(t);
  }, [justAdded]);

  return (
    <article className="product-card" aria-label={product.name}>
      <div className="product-icon" aria-hidden="true">
        {categoryIcon(product.category)}
      </div>
      <div className="product-body">
        <span className="product-category">{product.category}</span>
        <h3 className="product-name">{product.name}</h3>
        <span className="product-price">{formatMoney(product.unitPrice)}</span>
      </div>
      <button
        type="button"
        className="add-to-cart"
        onClick={() => {
          add(product);
          setJustAdded(true);
        }}
      >
        {justAdded ? "Added ✓" : "Add to cart"}
      </button>
    </article>
  );
}
